import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-inst',
  templateUrl: './inst.component.html',
  styleUrls: ['./inst.component.css']
})
export class InstComponent implements OnInit {

  constructor(
    private router: Router,
  ) { }

  usuario;
  token;

  ngOnInit(): void {
    this.usuario = JSON.parse(localStorage.getItem('user'));
    this.token = JSON.parse(localStorage.getItem('token'));
    if (this.token != 'superadmin' && this.token != 'instructor' && this.token != 'administrador' && this.token != 'editor') {
      this.router.navigate(['']);
    }
  }
}
